module.exports = __webpack_public_path__ + "static/media/signature.7efc8251.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/signature.svg
// module id = 811
// module chunks = 0